import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {InputSwitch} from "primereact/inputswitch";
import axios from "axios";

const FulfilmentitemFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fulfillment: window.App.urlVars().fulfillmentId,
  });
  const [items, setItems] = useState([]);
  const [units, setUnits] = useState([]);
  const [vats, setVats] = useState([]);
  const [projectItems, setProjectItems] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const payload = {
      ...data,
      fulfillment: String(window.App.urlVars().fulfillmentId ?? data.fulfillment ?? formData.fulfillment),
      unit_price: Number(data.unit_price ?? 0),
    };
    if (!(window.App.urlVars().create === 'fulfilmentitem' && window.App.urlVars().update !== 'fulfilmentitem' && (window.App.urlVars().mode === 'simple' || window.App.urlVars().mode === 'project'))) {
      payload.unit = String(data.unit?.id ?? data.unit ?? formData.unit?.id ?? formData.unit);
      payload.quantity = Number(data.quantity ?? formData.quantity ?? 0);
    }
    if (!(window.App.urlVars().create === 'fulfilmentitem' && window.App.urlVars().update !== 'fulfilmentitem' && (window.App.urlVars().mode === 'simple' || window.App.urlVars().mode === 'quantity'))) {
      payload.project_item = Number(data.project_item ?? formData.project_item);
    }
    if ((id && entity === 'fulfilmentitem') || (window.App.urlVars().update === 'fulfilmentitem' && window.App.urlVars().fulfilmentitemId)) {
      axios.patch(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment-item/" + (window.App.urlVars().fulfilmentitemId ?? id),
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          // window.App.setState({rerenderFulfilmentitemList: Math.random()})
          window.App.setState({
            rerenderFulfilmentitemList: Math.random(),
            rerenderFulfilmentList: Math.random(),
            rerenderRetentionList: Math.random()
          })
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/fulfilment/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      axios.post(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment-item",
        payload,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          // window.App.setState({rerenderFulfilmentitemList: Math.random()})
          window.App.setState({
            rerenderFulfilmentitemList: Math.random(),
            rerenderFulfilmentList: Math.random(),
            rerenderRetentionList: Math.random()
          })
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/fulfilment/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  useEffect(() => {
    const fulfillmentId = window.App.urlVars().fulfillmentId;
    const isUpdating =
      (id && entity === 'fulfilmentitem') ||
      (window.App.urlVars().update === 'fulfilmentitem' && window.App.urlVars().fulfilmentitemId);

    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-item?search[project][operator]=%3D&search[project][value]=" + (window.App.urlVars().projectId ?? id),
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setItems(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project-item?search[project][operator]=%3D&search[project][value]=" + (window.App.urlVars().projectId ?? id) + "&search[type][operator]=%3D&search[type][value]=material",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setProjectItems(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/vat-rate",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setVats(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/unit",
      {
        params: {},
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setUnits(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (fulfillmentId && !isUpdating) {
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment/" + fulfillmentId,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          const fulfillment = response?.data?.data || {};
          const contractVatRateId =
            fulfillment?.type === 'SUBCONTRACTOR'
              ? (fulfillment?.contract?.vat_rate?.id || fulfillment?.contract?.vat_rate || null)
              : null;

          if (contractVatRateId) {
            setFormData(prev => (
              prev?.vat_rate
                ? prev
                : {
                    ...prev,
                    vat_rate: contractVatRateId
                  }
            ));
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    if ((id && entity === 'fulfilmentitem') || (window.App.urlVars().update === 'fulfilmentitem' && window.App.urlVars().fulfilmentitemId)) {
      setLoading(true);
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/fulfillment-item/" + (window.App.urlVars().fulfilmentitemId ?? id),
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"action-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            {window.App.urlVars().mode !== 'project' && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="name" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="name"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                    <span className="p-d-block">
                        <InputText id="name" {...input}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        name: e.target.value
                                      })
                                    }}
                                    value={formData.name}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            {window.App.urlVars().mode === 'project' && (
              <div className={"p-col-12 p-lg-6"}>
                <Field name="project_item" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="project_item"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectItem')}</label>
                    <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  input.onChange(e.value)
                                  setFormData({
                                    ...formData,
                                    project_item: e.value
                                  })
                                }}
                                value={formData.project_item?.id || formData.project_item}
                                options={window.App.sortDropdownOptions(projectItems, "name")}
                                optionLabel="name"
                                optionValue="id"
                                id={"project_item"}
                                emptyMessage={t('noTopicYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                    </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            {/* <div className={"p-col-12 p-lg-6"}>
              <Field name="project_item" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="project_item"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldProjectItem')}</label>
                  <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    project_item: e.target.value
                                  })
                                }}
                                value={formData.project_item?.id || formData.project_item}
                                options={window.App.sortDropdownOptions(items, "name")}
                                optionLabel="name"
                                optionValue="id"
                                id={"project_item"}
                                emptyMessage={t('noTopicYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}
            <div className={"p-col-12 p-lg-2"}>
              <Field name="unit_price" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="unit_price"
                        className={classNames({'p-error': isFormFieldValid(meta)})}>
                    {window.App.urlVars().create === 'fulfilmentitem' && window.App.urlVars().update !== 'fulfilmentitem' && (window.App.urlVars().mode === 'simple' || window.App.urlVars().mode === 'project') ? t('netPrice') : t('unitPrice')}
                  </label>
                  <span className="p-d-block">
                      <InputNumber id="unit_price" {...input}
                                  mode="decimal"
                                  minFractionDigits={0}
                                  maxFractionDigits={9}
                                  locale="hu-HU"
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      unit_price: e.value
                                    })
                                  }}
                                  value={formData.unit_price}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <Field name="vat_rate" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="vat_rate"
                        className={classNames({'p-error': isFormFieldValid(meta)})}>
                    {window.App.urlVars().create === 'fulfilmentitem' && window.App.urlVars().update !== 'fulfilmentitem' && (window.App.urlVars().mode === 'simple' || window.App.urlVars().mode === 'project')
                      ? 'Áfa'
                      : 'ÁFA kulcs'}
                  </label>
                  <span className={"p-d-block"}>
                      <Dropdown {...input}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    vat_rate: e.target.value
                                  })
                                }}
                                value={formData.vat_rate?.id || formData.vat_rate}
                                options={window.App.sortDropdownOptions(vats, "label")}
                                optionLabel="label"
                                optionValue="id"
                                id={"vat_rate"}
                                emptyMessage={t('noVatYet')}
                                className={classNames({'p-error': isFormFieldValid(meta)})}
                      />
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {!(window.App.urlVars().create === 'fulfilmentitem' && window.App.urlVars().update !== 'fulfilmentitem' && (window.App.urlVars().mode === 'simple' || window.App.urlVars().mode === 'project')) && (
              <div className={"p-col-12 p-lg-2"}>
                <Field name="quantity" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="quantity"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCount')}</label>
                    <span className="p-d-block">
                        <InputNumber id="quantity" {...input}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        quantity: e.value
                                      })
                                    }}
                                    value={formData.quantity}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            {!(window.App.urlVars().create === 'fulfilmentitem' && window.App.urlVars().update !== 'fulfilmentitem' && (window.App.urlVars().mode === 'simple' || window.App.urlVars().mode === 'project')) && (
              <div className={"p-col-12 p-lg-2"}>
                <Field name="unit" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="unit"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldUnitOfMeasure')}</label>
                    <span className={"p-d-block"}>
                        <Dropdown {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      unit: e.target.value
                                    })
                                  }}
                                  value={formData.unit?.id || formData.unit}
                                  options={window.App.sortDropdownOptions(units, "name")}
                                  optionLabel="name"
                                  optionValue="id"
                                  id={"unit"}
                                  emptyMessage={t('noUnitYet')}
                                  className={classNames({'p-error': isFormFieldValid(meta)})}
                        />
                              </span>
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            )}
            <div className={"p-col-12 p-lg-2"}>
              <Field name="is_additional" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="is_additional"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldIsAdditional')}</label>
                  <span className="p-d-block">
                    <InputSwitch id="is_additional" {...input}
                      onChange={e => setFormData({...formData, is_additional: e.value})}
                      checked={formData.is_additional}
                      className={"p-mt-1"}
                      value={formData.successful}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNote')}</label>
                  <span className="p-d-block">
                      <InputText id="note" {...input}
                                   onChange={(e) => {
                                     setFormData({
                                       ...formData,
                                       note: e.target.value
                                     })
                                   }}
                                   value={formData.note}
                                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'action' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(FulfilmentitemFormComponent);
